<template>
	<div
		class="form-group text-left base-input"
		:class="{ buttonAddons: inputType === 'buttonAddons' }"
	>
		<label v-if="label" for="baseInput">{{ label }}</label>
		<input
			id="baseInput"
			class="form-control"
			:value="value"
			@input="valueUpdate"
			v-bind="$attrs"
			:type="type"
			:class="{ 'buttonAddons-input': inputType === 'buttonAddons' }"
		/>

		<mdb-btn
			v-if="inputType === 'buttonAddons'"
			@click.native.prevent="buttonClick"
			class="buttonAddons-button btn-color-primary"
			>{{ buttonText }}</mdb-btn
		>
		<p class="errorMsg" v-if="errorMsg">{{ errorMsg }}</p>
		<!-- <div class="group">
			<input type="text" required />
			<span class="highlight"></span>
			<span class="bar"></span>
			<label>Name</label>
		</div>-->
	</div>
</template>

<script>
import { mdbBtn } from 'mdbvue'

export default {
	inheritAttrs: false,
	props: {
		label: {
			type: [Number, String],
			default: ''
		},
		value: {
			type: [Number, String]
		},
		type: {
			type: String,
			default: 'text'
		},
		inputType: {
			type: String,
			default: 'basic'
		},
		buttonText: {
			type: String
		},
		buttonClick: {
			type: Function
		},
		errorMsg: {
			type: String
		}
	},
	methods: {
		valueUpdate(e) {
			let value = e.target.value
			this.$emit('input', value)
		}
	},
	components: {
		mdbBtn
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/baseInput.scss';
</style>
